module.exports = __webpack_public_path__ + "static/media/logo-nav.c62f8c42.png";